import { render } from "./SignatureView.vue?vue&type=template&id=4fe5d94c"
import script from "./SignatureView.vue?vue&type=script&lang=js"
export * from "./SignatureView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__